import Component from '@bythepixel/component-loader';
import { breakpoints } from '@Front/constants';
import windowMatchMedia from '@Front/constants/windowMatchMedia';
import GlideSlider from '../base';

const mainSliderGlideOptions = {
  breakpoints: {
    [breakpoints['break-1']]: {
      dragThreshold: 120,
    },
    [breakpoints['break-2'] - 1]: {
      gap: 12.5,
      dragThreshold: 120,
    },
  },
  dragThreshold: false,
  focusAt: 'center',
  gap: 16,
  perTouch: 1,
  rewind: false,
  type: 'slider',
};

const mainSliderSelectors = {
  slideSelector: '[data-vehicle-card-mobile-slider="slide"]',
  slideIndicatorSelector: '[data-vehicle-card-mobile-slider-indicator]',
  slideIndicatorActiveClass: 'glide__bullet--active',
};

export default class SectionVehicleCardsMobileSlider extends Component {
  static selector = '[data-comp-vehicle-card-mobile-slider]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);

    // @TODO: addListener is deprecated
    windowMatchMedia['break-3'].addListener(() => {
      this.toggleMainSlider();
    });

    this.toggleMainSlider();
  }

  toggleMainSlider() {
    // If mobile, initialize the main slider
    if (!windowMatchMedia['break-3'].matches) {
      this.initSliders();
    // If it's not mobile and the main slider was already initialized, destroy it
    } else if (windowMatchMedia['break-3'].matches && this.mainSliderGlideInstance) {
      this.mainSliderGlideInstance.destroy();
      this.mainSlider = null;
    }
  }

  initSliders() {
    this.mainSlider = new GlideSlider(
      this.$container,
      mainSliderGlideOptions,
      mainSliderSelectors,
    );
    this.mainSliderGlideInstance = this.mainSlider.getGlideSlider();
    this.mainSliderEl = this.mainSlider.getSliderElement();
    this.mainSliderLastSlide = this.mainSliderEl.querySelector('.vehicle-card:last-child');

    this.initMountEvents();
    this.initSwipeAndMouseEvents();
    this.initResizeEvents();

    this.mainSliderGlideInstance.mount();
  }

  getNewPerViewSetting() {
    const sliderWidth = this.mainSlider.getSliderWidth();
    const cardWidth = 348;
    const baseExpression = sliderWidth / cardWidth;

    const targetBreakpoints = {
      mobileSm: window.matchMedia('(max-width: 370px)').matches,
      mobile: window.matchMedia('(max-width: 600px)').matches,
      custom: window.matchMedia('(min-width: 600px)').matches,
      tablet: window.matchMedia('(min-width: 768px)').matches,
      desktop: window.matchMedia('(min-width: 1024px)').matches,
      desktopMd: window.matchMedia('(min-width: 1200px)').matches,
    };

    const updatedOptions = {
      perView: 1,
    };

    // At each breakpoint, the base expression is multiplied by
    // a coefficient that helps achieve certain slide widths. These
    // coefficients are the product of trial and error.
    if (targetBreakpoints.mobileSm) {
      updatedOptions.perView = baseExpression * 1.2;
    } else if (targetBreakpoints.mobile) {
      updatedOptions.perView = baseExpression * 1.1;
    } else if (targetBreakpoints.desktop) {
      updatedOptions.perView = baseExpression * 0.95;
    } else {
      updatedOptions.perView = baseExpression;
    }

    this.mainSliderGlideInstance.update(updatedOptions);
  }

  /*
   * Initializes mount events for vehicle slider container
   * @param {Glide}
   * @return {void}
   */
  initMountEvents() {
    // Run these events after mounting the slider
    this.mainSliderGlideInstance.on('mount.after', () => {
      this.getNewPerViewSetting();
      this.mainSlider.handleSlideIndicatorActiveState();
    });
  }

  /*
   * Initializes swipe/mouse events for vehicle slider container
   * @return {void}
   */
  initSwipeAndMouseEvents() {
    // Mouse dragging/clicking interaction event listener
    // Glide slider index has already been calculated
    // But the slide has not transitioned yet
    // This is why we check if it's past 0
    this.mainSliderGlideInstance.on('run', () => {
      this.mainSlider.handleSlideIndicatorActiveState();
    });
  }

  /*
   * Bugginess around the breakpoints requires the slider to be updated manually like this
   * @return {void}
   */
  initResizeEvents() {
    this.mainSliderGlideInstance.on('resize', () => {
      this.getNewPerViewSetting();
      this.mainSliderGlideInstance.update(mainSliderGlideOptions);
      if (!windowMatchMedia['break-2'].matches) {
        this.mainSlider.handleSlideIndicatorActiveState();
      }
    });
  }
}
